<div class="work-order-feedback">
  <app-section-header title="{{ 'workOrderFeedback.title' | translate }}"></app-section-header>

  <mat-card class="section-card" appearance="outlined">
    <div class="job-summary" *ngIf="workOrder as wo">
      <div class="summary-item">
        <span class="label">{{ 'workOrderFeedback.summary.workOrder' | translate }}</span>
        <span class="value">{{ wo.workOrderNumber }}</span>
      </div>
      <div class="summary-item">
        <span class="label">{{ 'workOrderFeedback.summary.title' | translate }}</span>
        <span class="value">{{ wo.title }}</span>
      </div>
      <div class="summary-item">
        <span class="label">{{ 'workOrderFeedback.summary.platform' | translate }}</span>
        <span class="value">{{ wo.siteNo || '-' }}</span>
      </div>
      @if (wo.activity?.functionalUnit) {
        <div class="summary-item">
          <span class="label">{{ 'workOrderFeedback.summary.taskNo' | translate }}</span>
          <span class="value">{{ wo.activity?.functionalUnit }}</span>
        </div>
      }
      <div class="summary-item">
        <span class="label">{{ 'workOrderFeedback.summary.date' | translate }}</span>
        <span class="value">{{ wo.startDate | date }}</span>
      </div>
    </div>

    <h3 class="prompt-title">{{ 'workOrderFeedback.prompt.title' | translate }}</h3>
    <p class="prompt-info">{{ 'workOrderFeedback.prompt.info' | translate }}</p>
    @if (!hasRecipientEmail()) {
      <p class="recipient-warning">{{ 'workOrderFeedback.recipientWarning' | translate }}</p>
    }

    <div class="sentiment-grid">
      @for (sentiment of sentiments; track sentiment) {
        <button
          type="button"
          class="sentiment-option"
          [class.selected]="isSelectedSentiment(sentiment)"
          (click)="selectSentiment(sentiment)"
        >
          <span class="emoji">{{ getSentimentEmoji(sentiment) }}</span>
          <span class="title">{{ getSentimentLabel(sentiment) }}</span>
        </button>
      }
    </div>
    @if (form.controls.sentiment.invalid && form.controls.sentiment.touched) {
      <p class="validation">{{ 'workOrderFeedback.validation.sentimentRequired' | translate }}</p>
    }
  </mat-card>

  <mat-card class="section-card" appearance="outlined">
    <h3 class="section-title">{{ 'workOrderFeedback.topicsTitle' | translate }}</h3>
    <div class="topics-grid">
      @for (topic of topics; track topic) {
        <mat-checkbox [checked]="isTopicSelected(topic)" (change)="toggleTopic(topic, $event.checked)">
          {{ getTopicLabel(topic) }}
        </mat-checkbox>
      }
    </div>

    <mat-form-field appearance="outline" class="full-width" floatLabel="always">
      <mat-label>
        {{ 'workOrderFeedback.commentLabel' | translate }}
        @if (isCommentRequired()) {
          *
        }
      </mat-label>
      <textarea
        matInput
        rows="4"
        [formControl]="form.controls.comment"
        [placeholder]="'workOrderFeedback.commentPlaceholder' | translate"
      ></textarea>
      @if (form.controls.comment.invalid && form.controls.comment.touched && isCommentRequired()) {
        <mat-error>{{ 'workOrderFeedback.validation.commentRequired' | translate }}</mat-error>
      }
    </mat-form-field>

    <div class="field-grid">
      <mat-form-field appearance="outline">
        <mat-label>{{ 'workOrderFeedback.impactLabel' | translate }}</mat-label>
        <mat-select [formControl]="form.controls.potentialImpacts" multiple>
          @for (impact of impacts; track impact) {
            <mat-option [value]="impact">{{ getImpactLabel(impact) }}</mat-option>
          }
        </mat-select>
        @if (isPotentialImpactInvalid()) {
          <mat-error>{{ 'workOrderFeedback.validation.potentialImpactRequired' | translate }}</mat-error>
        }
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>{{ 'workOrderFeedback.performedByLabel' | translate }}</mat-label>
        <input matInput [formControl]="form.controls.performedBy" readonly />
      </mat-form-field>
    </div>

    <mat-form-field appearance="outline" class="full-width" floatLabel="always">
      <mat-label>{{ 'workOrderFeedback.improvementLabel' | translate }}</mat-label>
      <textarea
        matInput
        rows="3"
        [formControl]="form.controls.suggestedImprovement"
        [placeholder]="'workOrderFeedback.improvementPlaceholder' | translate"
      ></textarea>
    </mat-form-field>

    <div class="actions">
      <button mat-flat-button color="primary" type="button" (click)="submit()" [disabled]="submitting">
        {{ (submitting ? 'workOrderFeedback.submitting' : 'workOrderFeedback.submit') | translate }}
      </button>
    </div>
  </mat-card>

  <mat-card class="section-card history" appearance="outlined">
    <h3 class="section-title">{{ 'workOrderFeedback.previousTitle' | translate }}</h3>

    @if (feedback.length === 0) {
      <app-empty-list
        color="secondary"
        title="{{ 'workOrderFeedback.empty.title' | translate }}"
        info="{{ 'workOrderFeedback.empty.info' | translate }}"
      ></app-empty-list>
    } @else {
      <div class="history-list">
        @for (item of feedback; track item.id ?? item.createdAt ?? $index) {
          <div class="history-item">
            <div class="history-head">
              <span class="history-emoji">{{ getSentimentEmoji(item.sentiment || '') }}</span>
              <div>
                <div class="history-title">{{ getSentimentLabel(item.sentiment || '') }}</div>
                <div class="history-time">{{ item.createdAt | date: 'short' }}</div>
              </div>
            </div>
            @if (item.comment) {
              <p class="history-comment">{{ item.comment }}</p>
            }
            <div class="history-meta">
              <span
                >{{ 'workOrderFeedback.impactLabel' | translate }}:
                {{ getImpactLabel(item.potentialImpact || '') }}</span
              >
              @if (item.performedBy) {
                <span>{{ 'workOrderFeedback.performedByLabel' | translate }}: {{ item.performedBy }}</span>
              }
            </div>
            <div class="history-actions">
              <button mat-stroked-button type="button" (click)="resend(item)" [disabled]="isResending(item.id)">
                {{ (isResending(item.id) ? 'workOrderFeedback.resending' : 'workOrderFeedback.resend') | translate }}
              </button>
            </div>
          </div>
        }
      </div>
    }
  </mat-card>
</div>
